import { useAuth } from "@/contexts/AuthContext";
import { Link } from "react-router-dom";
import { Buildings, ArrowRight } from "@phosphor-icons/react";
import { motion } from "framer-motion";

export const NoBusinessGuard = ({ children }) => {
  const { activeBusiness, loading } = useAuth();

  if (loading) return null;

  if (!activeBusiness) {
    return (
      <main className="max-w-lg mx-auto px-4 py-20">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-[var(--bg-card)] border border-[var(--border)] rounded-xl p-8 text-center"
          data-testid="no-business-guard"
        >
          <div className="w-14 h-14 mx-auto rounded-xl bg-[var(--accent-subtle)] flex items-center justify-center mb-5">
            <Buildings size={28} weight="fill" className="text-[#FF4400]" />
          </div>
          <h2 className="font-['Cormorant_Garamond'] text-xl font-bold text-[var(--text-primary)] mb-2">
            No Active Business
          </h2>
          <p className="text-sm text-[var(--text-muted)] mb-6 max-w-sm mx-auto">
            You need at least one business to start generating content. Each business has its own brand voice, templates, and content library.
          </p>
          <Link
            to="/settings?tab=workspace"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-[#FF4400] hover:bg-[#FF6633] text-white text-sm font-semibold transition-colors"
            data-testid="no-business-create-link"
          >
            <Buildings size={16} weight="bold" />
            Create a Business
            <ArrowRight size={14} />
          </Link>
        </motion.div>
      </main>
    );
  }

  return children;
};
